import { useSwitchLeague, type ResolvedLeague } from "@/contexts";
import { useT } from "@/i18n";
import { trackAction } from "@/lib/sentry";
import { IconButton, IconChevronLeft } from "@/ui";

type LeagueSidebarHeaderProps = {
  // Passed in (not read from context) so the panel keeps rendering the league
  // while it animates OUT after the league is cleared — reading live context
  // here would blank the title to null mid-exit.
  league: ResolvedLeague;
};

export const LeagueSidebarHeader = ({ league }: LeagueSidebarHeaderProps) => {
  const t = useT();
  const switchLeague = useSwitchLeague();

  // Clearing the league navigates back to the leagues list (`/tours`) and removes
  // the stored league id — see `switchLeague(null)` in CurrentLeagueContext.
  const handleBack = () => {
    trackAction("dashboard.sidebar.league.back", { leagueId: league.id });
    switchLeague(null);
  };

  return (
    <div className="flex items-center gap-2 min-w-0 mt-3">
      <IconButton
        icon={IconChevronLeft}
        onPress={handleBack}
        label={t("league.nav.backLabel")}
        variant="tertiary"
        color="muted"
        size="sm"
        hideTooltip
        className="shrink-0 text-new-primary"
      />
      <span className="preset-title-md text-new-primary truncate">{league.title}</span>
    </div>
  );
};
